const CANDIDATE_LOGS_COLLECTION = "candidate_logs";

const processDocs = (docs) => {
  const data = [];
  docs.forEach((doc) => {
    const elem = doc.data();
    elem.id = doc.id;
    data.push(elem);
  });
  return data;
};

function CandidateLogsMixin() {
  return {
    async createCandidateLog(candidateLog) {
      const docRef = await this.collection(CANDIDATE_LOGS_COLLECTION).add(candidateLog);
      return docRef.id;
    },
    async findCandidatesByCampaignId(campaignId, { type, value }) {
      let query = this.collection(CANDIDATE_LOGS_COLLECTION).where("campaignId", "==", campaignId);

      if (type) {
        query = query.where("type", "==", type);
      }

      if (value) {
        query = query.where("value", "==", value);
      }

      return query.get().then((querySnapshot) => processDocs(querySnapshot));
    },
    async findCandidateLogsByCandidateId(candidateId) {
      const query = this.collection(CANDIDATE_LOGS_COLLECTION).where(
        "candidateId",
        "==",
        candidateId
      );
      return query.get().then((querySnapshot) => processDocs(querySnapshot));
    }
  };
}

module.exports = CandidateLogsMixin;
